import { FaLink } from "react-icons/fa6";

export function Skills({ dataSkills }) {
    return (
        <div className='skills pt-4 pb-5'>
            <div className='skills__experience'>
                <h3 className="skill__experience__title mb-4">Experiencia</h3>
                <div className='skills__experience__box'>
                    {
                        dataSkills.experience.map((item, index) => (
                            <ExperienceCard
                                key={index}
                                experienceData={item} />
                        ))
                    }
                </div>
            </div>
            <div className='skills__box mt-4'>
                <h3 className="skills__box_title mb-4">Dominio de Tecnologías</h3>
                <div className='skill__box__tech'>
                    <ul className='skill__box__list ps-0'>
                        {
                            dataSkills.skills.map((item, index) => (
                                <TechList
                                    key={index}
                                    skillData={item} />
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
}

export function ExperienceCard({ experienceData }) {
    return (
        <div className='experience-card pb-3 pb-lg-4'>
            <div className='experience-card__body d-flex'>
                <div className='experience-card__image'>
                    <img className='experience-card__img' src={experienceData.companyLogo} alt='Logo de empresa' />
                </div>
                <div className='experience-card__text ms-2'>
                    <div className="experience-card__text-header d-flex align-items-center">
                        <p className='experience-card__position mb-0'>{experienceData.position}</p>
                        <ul className="experience-card__text-list mb-0 d-none d-sm-block">
                            <li className="experience-card__date">{experienceData.date}</li>
                        </ul>
                    </div>
                    <div className="experience-card__company-info d-flex">
                        <p className='experience-card__company mb-0 mb-sm-2'>{experienceData.companyName}</p>
                        {
                            experienceData.companyLink && (
                                <a className='experience-card__company-link ms-2' href={experienceData.companyLink} target="_blank" rel="noreferrer">
                                    <FaLink className="me-1" />
                                </a>
                            )
                        }
                    </div>
                    <p className='experience-card__date mb-2 d-sm-none'>{experienceData.date}</p>
                    <p className='experience-card__resume mb-0'>{experienceData.resume}</p>
                </div>
            </div>
        </div>
    );
}

export function TechList({ skillData }) {
    return (
        <li className='skills__item-list d-flex justify-content-between justify-content-sm-start align-items-center mb-4'>
            <p className='skills__item-list col-4 mb-0'>{skillData.techName}</p>
            <div className='skills__item-list__stick d-flex position-relative'>
                <div className='skills__item-list__progress' style={{ width: `${skillData.techExperience}` }}></div>
                <p className='skills__item-list__percent mb-0 position-absolute'>{skillData.techExperience}</p>
            </div>
        </li>
    );
}